import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Mail } from 'lucide-react';
import { XIcon } from '../ui/XIcon';
import PadaidLogo from '../ui/PadaidLogo';
import { useLanguage } from '../../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <PadaidLogo size="md" showText={true} />
            </div>
            <p className="text-muted-foreground mb-6 max-w-md">
              {t('footer.tagline')}
            </p>
            <div className="flex space-x-4">
              <a href="https://x.com/Padaid_Asso" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="X (Twitter)">
                <XIcon size={18} />
              </a>
              <a href="https://www.instagram.com/padaid_asso" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://www.youtube.com/@PADAID" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="YouTube">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Navigation rapide */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">{t('footer.navigation')}</h3>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">{t('footer.blog')}</Link></li>
              <li><Link to="/gallery" className="text-muted-foreground hover:text-primary transition-colors">{t('footer.gallery')}</Link></li>
              <li><Link to="/shop" className="text-muted-foreground hover:text-primary transition-colors">{t('footer.shop')}</Link></li>
              <li><Link to="/membership" className="text-muted-foreground hover:text-primary transition-colors">{t('footer.membership')}</Link></li>
              <li><Link to="/donate" className="text-muted-foreground hover:text-primary transition-colors">{t('footer.donate')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Mail size={16} className="text-primary" />
                <span className="text-muted-foreground text-sm">padaid.asso@gmail.com</span>
              </li>

            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} PADAID. {t('footer.rights')}
          </p>
          <div className="mt-3 flex justify-center gap-4 text-xs text-muted-foreground">
            <Link to="/mentions-legales" className="hover:text-primary transition-colors" data-testid="footer-legal-link">{t('footer.legal')}</Link>
            <Link to="/confidentialite" className="hover:text-primary transition-colors" data-testid="footer-privacy-link">{t('footer.privacy')}</Link>
            <Link to="/cgu" className="hover:text-primary transition-colors" data-testid="footer-cgu-link">{t('footer.cgu')}</Link>
          </div>
          <div className="mt-2">
            <Link 
              to="/admin/login" 
              className="text-xs text-muted-foreground/50 hover:text-muted-foreground transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;